<div class="vtz-main-wrapper" (window:resize)="onResize()">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <div class="vtz-no-print">
        <app-progress-bar [routeName]="routeName"></app-progress-bar>
      </div>
      <h2 class="vtz-h1" i18n>Affidavit</h2>
      <p class="vtz-text vtz-text--small vtz-text--xl-wide vtz-signature__affidavit-text" [innerHtml]="affidavitText"></p>
      <hr>
        <div id="signature-instructions" class="vtz-text vtz-text--wide vtz-text--center" i18n>Please sign below.  If you are unable to sign, please check the box and enter the PIN provided to you by your election official.
      </div>

      @if (markXSignature) {
        <div>
          <div class="form-row" role="form"  aria-labelledby="signature-instructions">
            <mat-checkbox style="transform: scale(2);"
              color="primary"
              [(ngModel)]="checked"
              (input)="handleCheck()"
              (change)="handleCheck()">
            </mat-checkbox>
            @if(!showButtons){
              <mat-form-field>
                <input matInput
                  aria-label="Enter the "
                  class="mat-input-element"
                  [(ngModel)]="signaturePIN"
                  #inputValueField="ngModel"
                  placeholder="6-digit PIN"
                  maxlength="6"
                  pattern="^[0-9]*$"
                  (input)="handleInput()"
                  (change)="handleInput()">
              </mat-form-field>
              @if (inputValueField.invalid) {
                <mat-error>Please enter digits only.</mat-error>
              }
            }
          </div>
        </div>
      }
      <div #wrapper id="signature-pad">
        <div class="vtz-signature__pad-container">
          <canvas (touchstart)="touchedCanvas()" (click)="touchedCanvas()" #canvas class="vtz-signature__box" width="600" height="331" style="touch-action: none;"></canvas>
        </div>

        @if(showButtons){
          <div class="button-group button-group--flat-mobile">
            <button id="cancel-button" i18n class="button-secondary button--tiny" (click)="clear()">CLEAR</button>
            <button id="submit-button" i18n class="button-secondary button--tiny" (click)="undo()">UNDO</button>
          </div>
        }
      </div>

      <div class="vtz-signature-actions">
        <p class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>Once you are satisfied with your signature, click submit, or return to the ballot to modify your selections.</p>
        <div class="vtz-actions">
          <div class="button-group button-group--flat-mobile">
            <button id="exit" class="button-secondary" (click)="exit()" i18n>EXIT</button>
            <button id="cancel-button" i18n class="button-secondary" (click)="returnToBallot()">RETURN TO BALLOT</button>
            <button [disabled]="isEmpty.getValue() && isPINincomplete.getValue()" id="open-submit-modal-button" i18n class="button-primary" (click)="openSubmitModal($event)">SUBMIT</button>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>